import * as yup from 'yup';

export const commonRefundSaptValidation: { [x: string]: any; } = {
    receiptNo: yup.string().required("Missing."),
};
export const commonRefundValidation: { [x: string]: any; } = {
    payeeName: yup.string().required("Missing."),
    receiptNo: yup.string().required("Missing."),
};

export const createRefundSaptValidation: { [x: string]: any; } = {
    ...commonRefundSaptValidation,
};
export const createRefundValidation: { [x: string]: any; } = {
    ...commonRefundValidation,
};

export const createRefundValidationSchema = yup.object().shape(createRefundValidation);
export const createRefundSaptValidationSchema = yup.object().shape(createRefundSaptValidation);

